export const CHILD_AGE_GENDER_QUALIFICATION_ID = 232;
export const CHILD_AGE_GENDER_NO_CHILDREN_CODE = 167;
